"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _material = require("@mui/material");

var _formatBytes = _interopRequireDefault(require("../../utilities/formatBytes"));

var _Typography = require("../Typography");

var _Icon = require("../Icon");

var _jsxRuntime = require("react/jsx-runtime");

var StyledBox = (0, _material.styled)(_material.Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "isConfirmingDelete";
  }
})(function (_ref) {
  var isConfirmingDelete = _ref.isConfirmingDelete;
  return {
    opacity: isConfirmingDelete ? "50%" : "100%"
  };
});

var File = function File(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledBox, {
    isConfirmingDelete: props.isConfirmingDelete,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.Typography, {
      color: "primary",
      component: "span",
      variant: "body2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        color: "primary",
        iconName: "file-alt",
        mr: 2
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: props.fileName
      })]
    }), props.fileSize && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.Typography, {
      color: "textSecondary",
      component: "span",
      variant: "body3",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        component: "span",
        mr: 2
      }), "(".concat((0, _formatBytes.default)(props.fileSize), ")")]
    })]
  });
};

var _default = File;
exports.default = _default;